<template>
	<div class="order-auto-match-rule">
		<div class="page-info">
			<span class="info-tag">订单自动匹配渠道规则</span>
			订单自动匹配渠道规则配置，店铺：
			<span class="shop-name">{{ shopName }}</span>
		</div>

		<div class="page-tips">
			<ul class="tips-list">
				<li>渠道综合价格 = 渠道价 + 运费</li>
				<li>根据渠道综合价格由小到大排列，价格低的优先匹配</li>
				<li>自动下单时，默认订单备注及插旗颜色可在下方各渠道配置中设置</li>
			</ul>
		</div>

		<el-form ref="form" v-loading="loading" :model="form" :rules="rules" label-width="280px" class="config-form">
			<div class="section-block">
				<div class="section-title">通用配置</div>
				<el-form-item label="自动下单" prop="autoOrder">
					<div class="field-row field-row--radio">
						<el-radio-group v-model="form.autoOrder" class="inline-radio-group">
							<el-radio label="manual">手动下单</el-radio>
							<el-radio label="auto">自动下单</el-radio>
						</el-radio-group>
					</div>
				</el-form-item>
				<el-form-item label="不自动下单商品数量" prop="noAutoOrderQty">
					<div class="field-row">
						<el-select v-model="form.noAutoOrderQty" placeholder="请选择">
							<el-option
								v-for="item in quantityLimitOptions"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							/>
						</el-select>
						<p class="field-tip">当订单商品件数 ≥ 当前设定值，不自动下单</p>
					</div>
				</el-form-item>
				<el-form-item label="自动下单延时 (分钟)" prop="autoOrderDelay">
					<div class="field-row">
						<el-input-number v-model="form.autoOrderDelay" :precision="0" :min="0" :controls="false" />
						<p class="field-tip">支付时间 + 自动下单延时，超过该时间才自动下单</p>
					</div>
				</el-form-item>
				<el-form-item label="自动下单截止天数" prop="autoOrderDeadline">
					<div class="field-row">
						<el-input-number v-model="form.autoOrderDeadline" :precision="0" :min="1" :controls="false" />
						<p class="field-tip">预计发货时间</p>
					</div>
				</el-form-item>
				<el-form-item :label="platformName + '卖家备注写入平台订单'" prop="pddNoteTo1889">
					<div class="field-row">
						<el-select v-model="form.pddNoteTo1889" placeholder="请选择">
							<el-option v-for="item in writeOptions" :key="item.value" :label="item.label" :value="item.value" />
						</el-select>
						<p class="field-tip">是否将{{ platformName }}卖家备注复制到平台订单备注</p>
					</div>
				</el-form-item>
				<el-form-item label="平台订单备注" prop="order1889Note">
					<div class="field-row">
						<el-input v-model="form.order1889Note" placeholder="请填写平台订单备注" clearable />
						<p class="field-tip">用于自动下单，同步到平台订单系统</p>
					</div>
				</el-form-item>
				<el-form-item label="渠道退货政策自动写入订单备注" prop="returnPolicyToNote">
					<div class="field-row">
						<el-select v-model="form.returnPolicyToNote" placeholder="请选择">
							<el-option v-for="item in writeOptions" :key="item.value" :label="item.label" :value="item.value" />
						</el-select>
						<p class="field-tip">自动追加渠道退货政策到{{ platformName }}订单备注，如「渠道退货政策：0%+100%」</p>
					</div>
				</el-form-item>
				<el-form-item label="渠道订单价自动写入订单备注" prop="channelPriceToNote">
					<div class="field-row">
						<el-select v-model="form.channelPriceToNote" placeholder="请选择">
							<el-option v-for="item in writeOptions" :key="item.value" :label="item.label" :value="item.value" />
						</el-select>
						<p class="field-tip">自动追加渠道订单价到{{ platformName }}订单备注，如「渠道订单价：100元」</p>
					</div>
				</el-form-item>
				<el-form-item label="平台订单编号自动写入订单备注" prop="order1889NoToNote">
					<div class="field-row">
						<el-select v-model="form.order1889NoToNote" placeholder="请选择">
							<el-option v-for="item in writeOptions" :key="item.value" :label="item.label" :value="item.value" />
						</el-select>
						<p class="field-tip">自动追加平台订单号到{{ platformName }}订单备注，如「平台订单号：XX001」</p>
					</div>
				</el-form-item>
				<el-form-item label="撕防伪自动写入订单备注" prop="securityToNote">
					<div class="field-row">
						<el-select v-model="form.securityToNote" placeholder="请选择">
							<el-option v-for="item in writeOptions" :key="item.value" :label="item.label" :value="item.value" />
						</el-select>
						<p class="field-tip">是否将撕防伪信息追加到订单备注</p>
					</div>
				</el-form-item>
				<el-form-item label="预发日期自动写入订单备注" prop="shipDateToNote">
					<div class="field-row">
						<el-select v-model="form.shipDateToNote" placeholder="请选择">
							<el-option v-for="item in writeOptions" :key="item.value" :label="item.label" :value="item.value" />
						</el-select>
						<p class="field-tip">是否将预发日期追加到订单备注，如「2025-01-01」</p>
					</div>
				</el-form-item>
				<el-form-item label="鞋子类目，优先加纸盒快递" prop="shoeBoxExpress">
					<div class="field-row">
						<el-select v-model="form.shoeBoxExpress" placeholder="请选择">
							<el-option label="否" :value="0" />
							<el-option label="是" :value="1" />
						</el-select>
						<p class="field-tip">鞋子类目订单是否优先匹配加纸盒快递</p>
					</div>
				</el-form-item>
			</div>

			<div class="section-block">
				<div class="section-title">必选渠道配置</div>
				<el-form-item label="必选渠道，自动下单" prop="mandatoryAutoOrder">
					<div class="field-row field-row--wide">
						<el-select v-model="form.mandatoryAutoOrder" placeholder="请选择">
							<el-option
								v-for="item in mandatoryAutoOrderOptions"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							/>
						</el-select>
						<p class="field-tip">全局控制必选渠道自动/手动下单</p>
					</div>
				</el-form-item>
				<el-form-item :label="platformName + '订单颜色标记 (自动下单)'" prop="mandatoryOrderColor">
					<div class="field-row">
						<el-radio-group v-model="form.mandatoryOrderColor" class="color-radio-group">
							<el-radio v-for="item in colorOptions" :key="item.value" :label="item.value">
								<span class="color-dot" :style="{ background: item.color }" />
								<span class="color-label">{{ item.label }}</span>
							</el-radio>
						</el-radio-group>
					</div>
				</el-form-item>
				<el-form-item :label="platformName + '订单卖家备注'" prop="mandatorySellerNote">
					<div class="field-row">
						<el-input v-model="form.mandatorySellerNote" placeholder="请填写卖家备注" clearable />
						<p class="field-tip">用于自动下单，同步到{{ platformName }}，针对必选渠道</p>
					</div>
				</el-form-item>
			</div>

			<div class="section-block">
				<div class="section-title">非必选渠道配置</div>
				<el-form-item label="退货政策" prop="optionalReturnPolicy">
					<div class="field-row">
						<el-select v-model="form.optionalReturnPolicy" placeholder="请选择">
							<el-option
								v-for="item in returnPolicyOptions"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							/>
						</el-select>
						<p class="field-tip">自动匹配渠道时使用</p>
					</div>
				</el-form-item>
				<el-form-item label="利润大于多少自动下单 (元)" prop="profitThreshold">
					<div class="field-row">
						<el-input-number v-model="form.profitThreshold" :min="0" :precision="2" :controls="false" />
						<p class="field-tip">利润 = {{ platformName }}实收 - 渠道综合价格；大于该值时自动下单</p>
					</div>
				</el-form-item>
				<el-form-item :label="platformName + '订单颜色标记 (自动下单)'" prop="optionalOrderColor">
					<div class="field-row">
						<el-radio-group v-model="form.optionalOrderColor" class="color-radio-group">
							<el-radio v-for="item in colorOptions" :key="item.value" :label="item.value">
								<span class="color-dot" :style="{ background: item.color }" />
								<span class="color-label">{{ item.label }}</span>
							</el-radio>
						</el-radio-group>
					</div>
				</el-form-item>
				<el-form-item :label="platformName + '订单卖家备注'" prop="optionalSellerNote">
					<div class="field-row">
						<el-input v-model="form.optionalSellerNote" placeholder="请填写卖家备注" clearable />
						<p class="field-tip">用于自动下单，同步到{{ platformName }}</p>
					</div>
				</el-form-item>
			</div>

			<div class="form-actions">
				<el-button type="primary" :loading="saving" @click="onSave">保存</el-button>
			</div>
		</el-form>
	</div>
</template>

<script>
import {
	buildOrderMatchRuleSavePayload,
	fetchOrderMatchRule,
	getRetailShopId,
	mapOrderMatchRuleToForm,
	saveOrderMatchRule,
} from './retailShopOrderMatchRule'
import taobaoPlatformMixin from './taobaoPlatformMixin'

const DEFAULT_FORM = {
	autoOrder: 'manual',
	noAutoOrderQty: 100,
	autoOrderDelay: 0,
	autoOrderDeadline: 1,
	pddNoteTo1889: 'write',
	order1889Note: '接口自动下单',
	returnPolicyToNote: 'write',
	channelPriceToNote: 'write',
	order1889NoToNote: 'write',
	securityToNote: 'no_write',
	shipDateToNote: 'no_write',
	shoeBoxExpress: 0,
	mandatoryAutoOrder: 'manual',
	mandatoryOrderColor: 3,
	mandatorySellerNote: '接口自动下单',
	optionalReturnPolicy: 'all',
	profitThreshold: 0,
	optionalOrderColor: 3,
	optionalSellerNote: '接口自动下单',
}

export default {
	name: 'OrderAutoMatchRule',
	mixins: [taobaoPlatformMixin],
	inject: {
		retailShop: { default: null },
	},
	data() {
		return {
			loading: false,
			saving: false,
			form: JSON.parse(JSON.stringify(DEFAULT_FORM)),
			rules: {
				autoOrder: [{ required: true, message: '请选择', trigger: 'change' }],
				noAutoOrderQty: [{ required: true, message: '请选择', trigger: 'change' }],
				autoOrderDelay: [{ required: true, message: '请填写', trigger: 'blur' }],
				autoOrderDeadline: [{ required: true, message: '请填写', trigger: 'blur' }],
				pddNoteTo1889: [{ required: true, message: '请选择', trigger: 'change' }],
				order1889Note: [{ required: true, message: '请填写', trigger: 'blur' }],
				returnPolicyToNote: [{ required: true, message: '请选择', trigger: 'change' }],
				channelPriceToNote: [{ required: true, message: '请选择', trigger: 'change' }],
				order1889NoToNote: [{ required: true, message: '请选择', trigger: 'change' }],
				securityToNote: [{ required: true, message: '请选择', trigger: 'change' }],
				shipDateToNote: [{ required: true, message: '请选择', trigger: 'change' }],
				shoeBoxExpress: [{ required: true, message: '请选择', trigger: 'change' }],
				mandatoryAutoOrder: [{ required: true, message: '请选择', trigger: 'change' }],
				mandatoryOrderColor: [{ required: true, message: '请选择', trigger: 'change' }],
				mandatorySellerNote: [{ required: true, message: '请填写', trigger: 'blur' }],
				optionalReturnPolicy: [{ required: true, message: '请选择', trigger: 'change' }],
				profitThreshold: [{ required: true, message: '请填写', trigger: 'blur' }],
				optionalOrderColor: [{ required: true, message: '请选择', trigger: 'change' }],
				optionalSellerNote: [{ required: true, message: '请填写', trigger: 'blur' }],
			},
			quantityLimitOptions: Array.from({ length: 100 }, (_, i) => ({
				value: i + 1,
				label: String(i + 1),
			})),
			writeOptions: [
				{ value: 'write', label: '写入' },
				{ value: 'no_write', label: '不写入' },
			],
			mandatoryAutoOrderOptions: [
				{ value: 'auto', label: '自动下单' },
				{ value: 'manual', label: '手动下单' },
			],
			returnPolicyOptions: [
				{ value: 'all', label: '全部渠道' },
				{ value: 'exclude0_100', label: '不匹配退货政策 0%+100% 的渠道' },
				{ value: 'only100_0', label: '只匹配退货政策 100%+0% 的渠道' },
			],
			colorOptions: [
				{ value: 1, label: '红色', color: '#f56c6c' },
				{ value: 2, label: '黄色', color: '#e6a23c' },
				{ value: 3, label: '绿色', color: '#67c23a' },
				{ value: 4, label: '蓝色', color: '#409eff' },
				{ value: 5, label: '紫色', color: '#9b59b6' },
			],
		}
	},
	computed: {
		shopName() {
			return (this.retailShop && this.retailShop.shopName) || ''
		},
	},
	watch: {
		'retailShop.currentShopId': {
			immediate: true,
			handler(id) {
				if (id) {
					this.fetchConfig()
				} else {
					this.resetForm()
				}
			},
		},
	},
	methods: {
		resetForm() {
			this.form = JSON.parse(JSON.stringify(DEFAULT_FORM))
		},
		applyConfig(data) {
			const mapped = mapOrderMatchRuleToForm(data)
			const form = JSON.parse(JSON.stringify(DEFAULT_FORM))
			let key
			for (key in mapped) {
				if (mapped[key] !== undefined) {
					form[key] = mapped[key]
				}
			}
			this.form = form
		},
		fetchConfig() {
			const shopId = getRetailShopId(this.retailShop)
			if (!shopId) {
				return
			}
			this.loading = true
			fetchOrderMatchRule(this.$axios, shopId).then(data => {
				this.applyConfig(data)
			}).catch(err => {
				console.log(err)
				this.$message.error(err.message || '获取订单自动匹配渠道规则失败')
			}).finally(() => {
				this.loading = false
			})
		},
		onSave() {
			this.$refs.form.validate((valid) => {
				if (!valid) return
				const shopId = getRetailShopId(this.retailShop)
				if (!shopId) {
					this.$message.warning('店铺信息不完整')
					return
				}
				this.saving = true
				const payload = buildOrderMatchRuleSavePayload(shopId, this.form)
				saveOrderMatchRule(this.$axios, payload).then(() => {
					this.fetchConfig()
					this.$message.success('保存成功')
				}).catch(err => {
					console.log(err)
					this.$message.error(err.message || '保存失败')
				}).finally(() => {
					this.saving = false
				})
			})
		},
	},
}
</script>

<style scoped lang="less">
.order-auto-match-rule {
	padding: 24px 28px 40px;
	background: #fff;
	min-height: 100%;
	box-sizing: border-box;
}

.page-info {
	margin-bottom: 16px;
	padding: 14px 18px;
	font-size: 14px;
	line-height: 1.6;
	color: #606266;
	background: #fafbfc;
	border-left: 3px solid #67c23a;
	border-radius: 0 6px 6px 0;

	.info-tag {
		display: inline-block;
		margin-right: 8px;
		padding: 2px 10px;
		font-size: 12px;
		color: #409eff;
		background: rgba(64, 158, 255, 0.08);
		border-radius: 3px;
		vertical-align: middle;
	}

	.shop-name {
		color: #ff4714;
		font-weight: 500;
	}
}

.page-tips {
	margin-bottom: 24px;
	padding: 14px 18px;
	background: #fafbfc;
	border-radius: 6px;
	border: 1px solid #f0f2f5;

	.tips-list {
		margin: 0;
		padding-left: 18px;
		font-size: 13px;
		line-height: 1.9;
		color: #909399;

		li {
			margin: 0;
		}
	}
}

.config-form {
	max-width: 100%;

	/deep/ .el-form-item {
		margin-bottom: 18px;
	}

	/deep/ .el-form-item__label {
		font-size: 12px;
		color: #606266;
		line-height: 36px;
		padding-right: 16px;
	}

	/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label::before {
		color: #f56c6c;
	}
}

.section-block {
	margin-bottom: 28px;
	padding: 20px 20px 8px;
	background: #fafbfc;
	border: 1px solid #f0f2f5;
	border-radius: 6px;
}

.section-title {
	margin: -20px -20px 20px;
	padding: 12px 20px;
	font-size: 14px;
	font-weight: 500;
	color: #303133;
	background: #f7f9fc;
	border-bottom: 1px solid #eef0f3;
	border-left: 3px solid #67c23a;
	border-radius: 6px 6px 0 0;
}

.field-row {
	display: flex;
	flex-wrap: wrap;
	align-items: flex-start;
	gap: 16px;
	max-width: 100%;

	.el-input,
	.el-select,
	.el-input-number {
		width: 280px;
		flex-shrink: 0;
	}

	&--wide .el-select {
		width: 480px;
		max-width: 100%;
	}

	&--radio {
		align-items: center;

		.field-tip {
			margin: 0;
			padding-top: 0;
		}
	}

	/deep/ .el-input-number .el-input__inner {
		text-align: left;
	}

	/deep/ .el-input__inner {
		height: 36px;
		line-height: 36px;
		border-color: #e8eaed;
		border-radius: 4px;
		background: #fff;
		transition: all 0.2s;

		&:hover {
			border-color: #dcdfe6;
		}

		&:focus {
			border-color: #ff4714;
		}
	}
}

.field-tip {
	flex: 1;
	min-width: 240px;
	margin: 10px 0 0;
	padding-top: 2px;
	font-size: 11px;
	color: #b0b3b8;
	line-height: 1.6;
}

.inline-radio-group {
	flex-shrink: 0;
	display: inline-flex;
	align-items: center;
	height: 36px;

	/deep/ .el-radio {
		display: inline-flex;
		align-items: center;
		margin-right: 24px;
		line-height: 1;

		&:last-child {
			margin-right: 0;
		}
	}

	/deep/ .el-radio__label {
		font-size: 14px;
		line-height: 1;
		padding-left: 8px;
	}
}

.color-radio-group {
	display: flex;
	flex-wrap: wrap;
	gap: 16px;
	padding-top: 8px;

	/deep/ .el-radio {
		display: inline-flex;
		align-items: center;
		margin-right: 0;
		line-height: 1;
	}

	/deep/ .el-radio__label {
		display: inline-flex;
		align-items: center;
		gap: 6px;
		padding-left: 6px;
		font-size: 12px;
		color: #606266;
	}
}

.color-dot {
	display: inline-block;
	width: 16px;
	height: 16px;
	border-radius: 50%;
	border: 2px solid rgba(0, 0, 0, 0.08);
	flex-shrink: 0;
}

.color-label {
	line-height: 1;
}

.form-actions {
	display: flex;
	justify-content: center;
	margin-top: 8px;
	padding-top: 24px;

	.el-button {
		min-width: 120px;
		height: 36px;
		padding: 0 32px;
		font-size: 12px;
		border-radius: 4px;
		letter-spacing: 2px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/StoreConfig/detailed/orderAutoMatchRule.vue